export default {
    methods: {
        getErrorTranslation(lang, field) {

            return this.block?.errors?.translations?.[lang]?.[field];
        }
    }
}